import React from "react";
import { ChangePassword } from "@/components/ChangePassword";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import logoDark from "@/assets/logo-dark.png";

export default function PrimeiroAcesso() {
  const { user, logout } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/dashboard" replace />;
  return (
    <div className="min-h-screen bg-onyx flex flex-col items-center justify-center p-4" data-testid="primeiro-acesso-page">
      <img src={logoDark} alt="TRT" className="h-12 mb-6" />
      <div className="w-full max-w-md bg-white rounded-2xl p-6 space-y-3">
        <h1 className="text-xl font-extrabold">Defina sua nova senha</h1>
        <p className="text-sm text-slate-500">Olá, {user.name}. Esta é uma senha temporária: por segurança, crie uma senha pessoal para continuar.</p>
        <ChangePassword onDone={() => { window.location.href = "/atendimentos"; }} />
        <button type="button" className="text-xs text-slate-400 underline" onClick={async () => { await logout(); window.location.href = "/login"; }} data-testid="primeiro-acesso-sair">Sair</button>
      </div>
    </div>
  );
}
